<div class="modal-header d-flex align-items-center justify-content-between">
  <h2 class="xs-title bold">{{ "create_new_workspace" | translate }}</h2>
  <button
    (click)="closeDialog()"
    type="button"
    class="btn btn-link ms-auto p-0"
    data-bs-dismiss="modal"
    aria-label="Close"
  >
    <app-icon icon="xmark"></app-icon>
  </button>
</div>
<div class="modal-body">
  <ul class="create-workspace-hints d-flex flex-column gap-2 px-3">
    <li class="m-body regular">{{ "workspace_hint_1" | translate }}</li>
    <li class="m-body regular">{{ "workspace_hint_2" | translate }}</li>
    <li class="m-body regular">{{ "workspace_hint_3" | translate }}</li>
  </ul>
  <div class="mb-3 d-flex flex-column mt-3">
    <label for="workspaceName" class="form-label">{{ "name_workspace_label" | translate }}</label>
    <input
      type="text"
      class="form-control"
      id="workspaceName"
      placeholder="{{ 'enter_workspace_name' | translate }}"
      data-cy="med_workspace_name_input"
      [(ngModel)]="workspaceName"
    />
  </div>
  <button
    class="btn btn-primary w-100"
    (click)="createNewWorkspace()"
    data-cy="med_create_workspace_button"
    [disabled]="!workspaceName || isCreating"
  >
    {{ "create_workspace" | translate }}
  </button>
</div>
